import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { api } from '@/utils/api';
import { AppThunk, AppDispatch } from '../store'; // Asegúrate de importar AppThunk y AppDispatch desde la definición del store
import { getOrganizationSettingsAction } from './organizationSlice';
import UserService from '@/domain/Users/UserService';
// Definimos el tipo de estado para `security`
interface SecurityState {
  array: any;
  fetching: boolean;
  error?: string;
  hasAcceptedEula?: boolean;
  requiresEulaAcceptance?: boolean;
  eulaVersion?: number;
}

// Estado inicial de `security`
const initialState: SecurityState = {
  array: localStorage.getItem('security')
    ? JSON.parse(localStorage.getItem('security')!)
    : {},
  fetching: false,
};

const securitySlice = createSlice({
  name: 'security',
  initialState,
  reducers: {
    getSecurity(state) {
      state.fetching = true;
    },
    getSecuritySuccess(state, action: PayloadAction<any>) {
      state.fetching = false;
      state.array = action.payload;
      state.hasAcceptedEula = action.payload.hasAcceptedEula;
      state.requiresEulaAcceptance = action.payload.requiresEulaAcceptance;
      state.eulaVersion = action.payload.eulaVersion;
    },
    getSecurityError(state, action: PayloadAction<string>) {
      state.fetching = false;
      state.error = action.payload;
    },
    clearSecurity() {
      return initialState;
    },
    updateEulaAcceptance(state, action: PayloadAction<boolean>) {
      state.hasAcceptedEula = action.payload;
      if (state.array) {
        state.array.hasAcceptedEula = action.payload;
        localStorage.setItem('security', JSON.stringify(state.array));
      }
    },
  },
});

export const {
  getSecurity,
  getSecuritySuccess,
  getSecurityError,
  clearSecurity,
  updateEulaAcceptance,
} = securitySlice.actions;
export default securitySlice.reducer;

// Thunk para realizar la acción de obtener seguridad
export const getSecurityAction =
  (userId: string) => async (dispatch: AppDispatch) => {
    dispatch(getSecurity());
    try {
      const res = await api.get(`users/${userId}`);
      
      localStorage.setItem('security', JSON.stringify(res.data));
      dispatch(getSecuritySuccess(res.data));
      dispatch(getOrganizationSettingsAction(res.data.organizationId));
    } catch (err: any) {
      console.error('❌ Error fetching security data:', err);
      dispatch(getSecurityError(err.response?.message || 'Error desconocido'));
    }
  };

// Thunk para aceptar EULA
export const acceptEulaAction =
  (userId: string, eulaVersion: number) => async (dispatch: AppDispatch) => {
    try {
      const userService = new UserService();
      await userService.acceptEula(userId, eulaVersion);
      dispatch(updateEulaAcceptance(true));
      return true;
    } catch (err: any) {
      console.error('Error accepting EULA:', err);
      return false;
    }
  };
